export const getDataAudio = ({ audioPlayer }) => audioPlayer.dataAudio;
export const getPlaying = ({ audioPlayer }) => audioPlayer.playAudio;
export const getShowPlayer = ({ audioPlayer }) => audioPlayer.showPlayer

